import { useState, useEffect } from 'react'

// Global state to ensure all timers are synced
let globalEndTime: number | null = null

export function useCountdown(initialMinutes = 10, initialSeconds = 43) {
  const [timeLeft, setTimeLeft] = useState({
    minutes: initialMinutes,
    seconds: initialSeconds,
    formatted: `${String(initialMinutes).padStart(2, '0')}:${String(initialSeconds).padStart(2, '0')}`,
  })

  useEffect(() => {
    if (!globalEndTime) {
      globalEndTime = Date.now() + (initialMinutes * 60 + initialSeconds) * 1000
    }

    const interval = setInterval(() => {
      const now = Date.now()
      const distance = globalEndTime! - now

      if (distance <= 0) {
        clearInterval(interval)
        setTimeLeft({
          minutes: 0,
          seconds: 0,
          formatted: '00:00',
        })
        return
      }

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      setTimeLeft({
        minutes,
        seconds,
        formatted: `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [initialMinutes, initialSeconds])

  return timeLeft
}
